import { render, staticRenderFns } from "./TechTalent.vue?vue&type=template&id=42af8633&"
import script from "./TechTalent.vue?vue&type=script&lang=js&"
export * from "./TechTalent.vue?vue&type=script&lang=js&"
import style0 from "./TechTalent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports